import { FormInstance } from 'antd';
import { CompressorOption, Room, Compressor } from '../../RoomConfigurationContent.utils';
import { ImageTags } from '@/constants/CompressorImageTagData.const';

export interface RoomContainerProps {
  room: Room;
  pressureType: string;
  showDrawer: boolean;
  isMobile: boolean;
  isTablet: boolean;
  onRemoveRoom: (roomId: number) => void;
  onAddManualCompressor: (roomId: number) => void;
  onRemoveCompressor: (roomId: number, compressorIndex: number) => void;
  onUpdateManualCompressorField: (roomId: number, compressorIndex: number, field: string, value: string) => void;
  onUpdateCompressorSpecDetails: (roomId: number, compressorId: string, field: string, value: number | null) => void;
  onOpenCompressorImageUpload: (compressorId: string, currentImageCount: number) => void;
  onRemoveCompressorImage: (roomId: number, compressorIndex: number, tag: ImageTags, imageId: number) => void;
  onEditCompressorImageTag: (
    roomId: number,
    compressorIndex: number,
    id: number,
    newTag: ImageTags,
    currentTag: ImageTags,
  ) => void;
  onAddTank: (roomId: number) => void;
  onRemoveTank: (roomId: number, tankId: string) => void;
  onAddDryer: (roomId: number) => void;
  onRemoveDryer: (roomId: number, dryerId: string) => void;
  getAvailableCompressorsForRoom: (roomId: number) => CompressorOption[];
  getRoomIndex: (rooms: Room[], roomId: number) => number;
  renderCompressorNumberInput: (roomId: number, compressorId: string, index: number) => React.ReactNode;
  renderModelSpecSelect: (roomId: number, compressorId: string, index: number) => React.ReactNode;
  handleCompressorSelection: (roomId: number, selectedSerialNumbers: string[]) => void;
  openCompressorDrawer: (roomId: number) => void;
  form: FormInstance;
  rooms: Room[];
}

export const getRoomName = (room: Room, roomIndex: number): string => {
  return room.name || 'Room ' + (roomIndex + 1);
};

export const getCompressorsWithIndex = (compressors: Compressor[]) => {
  return compressors.map((compressor, index) => ({ compressor, originalIndex: index }));
};

export const filterCompressorsByType = (
  compressorsWithIndex: { compressor: Compressor; originalIndex: number }[],
  isManual: boolean,
) => {
  return compressorsWithIndex.filter(({ compressor }) => compressor.isManual === isManual);
};

export const hasCompressorsOfType = (compressors: Compressor[], isManual: boolean): boolean => {
  return compressors.filter(compressor => compressor.isManual === isManual).length > 0;
};

export const getFilteredCompressorsWithIndex = (compressors: Compressor[], isManual: boolean) => {
  const compressorsWithIndex = getCompressorsWithIndex(compressors);
  return filterCompressorsByType(compressorsWithIndex, isManual);
};
